import React, { useState } from "react";
import SignInForm from "./SignInForm";
import ForgotPasswordModal from "../../Components/auth/ForgotPassword/ForgotPasswordFlow";

const SignInModal = ({ onClose, onSwitchToSignUp }) => {
  const [showForgot, setShowForgot] = useState(false);

  return (
    <>
      {!showForgot && (
        <SignInForm
          onClose={onClose}
          onSwitchToSignUp={onSwitchToSignUp} 
          onForgot={() => setShowForgot(true)}
        />
      )}

      {showForgot && (
        <ForgotPasswordModal
          onClose={() => setShowForgot(false)}
        />
      )}
    </>
  );
};

export default SignInModal;
